module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.a5caf972.xml";